import React from 'react';
import PropTypes from 'prop-types';
import ToastBanner from '../ToastBanner';

/**
 * @param {{children: ReactNode, showError: boolean, errorTitle: string, onCloseErrorMessage: function, hyperlink?: {url: string, text: string} | {}}} props
 */
const ErrorBanner = ({
  children,
  showError = false,
  errorTitle = undefined,
  onCloseErrorMessage,
  hyperlink = {},
}) => {
  if (!showError) return null;

  return (
    showError && (
    <ToastBanner type="error" title={errorTitle} onClickCloseButton={onCloseErrorMessage}>
      {children}
      {
        hyperlink.url && (
          <div>
            <a href={hyperlink.url}>
              {hyperlink.text}
            </a>
          </div>
        )
      }
    </ToastBanner>
    )
  );
};

ErrorBanner.propTypes = {
  showError: PropTypes.bool,
  children: PropTypes.node.isRequired,
  errorTitle: PropTypes.string,
  onCloseErrorMessage: PropTypes.func.isRequired,
  hyperlink: PropTypes.object,
};

export default ErrorBanner;
